import React, {Component} from 'react';
import MatchWhenLoggedIn from '../MatchWhenLoggedIn'
import ReportSoggettiView from '../report/ReportSoggettiView'

class PrintDispatcher extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="sixteen wide column" id="content">
        <MatchWhenLoggedIn exact path='/print/rubrica/soggettiViewCompact' component={ReportSoggettiView} {...this.props}/>

      </div>
    )
  }
}

export default PrintDispatcher;




/** WEBPACK FOOTER **
 ** ./src/components/print/PrintDispatcher.js
 **/